// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__UHvFA","controls":"styles_controls__LF3Vw","charLimit":"styles_charLimit__3YmUi","input":"styles_input__NwrPD","send":"styles_send__3brwq"};